import { type Config } from "@/apps/whiteLabelWebsite/whiteLabel/core/domain/whiteLabelConfig/Config";
import { type ConfigRepositoryInterface } from "@/apps/whiteLabelWebsite/whiteLabel/core/domain/whiteLabelConfig/ConfigRepositoryInterface";
import configRepository from "@/apps/whiteLabelWebsite/whiteLabel/core/infrastructure/repository/configRepository";

class ConfigQuery {
  private configRepository: ConfigRepositoryInterface;
  private config: Readonly<Config> | undefined;

  constructor(configRepository: ConfigRepositoryInterface) {
    this.configRepository = configRepository;
  }

  isConfigSuccessfullyLoaded(): Promise<boolean> {
    return this.configRepository
      .get()
      .then((config) => {
        this.config = config;
        return true;
      })
      .catch(() => false);
  }

  getConfig(): Readonly<Config> {
    if (!this.config) {
      throw new Error('You must wait the config to be loaded, through "await configQuery.getConfigPromise()"');
    }
    return this.config;
  }
}

const configQuery = new ConfigQuery(configRepository);
export default configQuery;
